/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ContactPropertyLink
 */
export interface ContactPropertyLink {
    /**
     * 
     * @type {number}
     * @memberof ContactPropertyLink
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof ContactPropertyLink
     */
    companyId: number;
    /**
     * 
     * @type {number}
     * @memberof ContactPropertyLink
     */
    contactId: number;
    /**
     * 
     * @type {number}
     * @memberof ContactPropertyLink
     */
    propertyId: number;
    /**
     * 
     * @type {string}
     * @memberof ContactPropertyLink
     */
    addressType: string;
    /**
     * 
     * @type {boolean}
     * @memberof ContactPropertyLink
     */
    isPrimary: boolean;
    /**
     * Enriched street address from joined property table
     * @type {string}
     * @memberof ContactPropertyLink
     */
    streetAddress?: string;
    /**
     * 
     * @type {string}
     * @memberof ContactPropertyLink
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof ContactPropertyLink
     */
    state?: string;
    /**
     * 
     * @type {string}
     * @memberof ContactPropertyLink
     */
    zipCode?: string;
    /**
     * 
     * @type {Date}
     * @memberof ContactPropertyLink
     */
    createdAt: Date;
}

/**
 * Check if a given object implements the ContactPropertyLink interface.
 */
export function instanceOfContactPropertyLink(value: object): value is ContactPropertyLink {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('contactId' in value) || value['contactId'] === undefined) return false;
    if (!('propertyId' in value) || value['propertyId'] === undefined) return false;
    if (!('addressType' in value) || value['addressType'] === undefined) return false;
    if (!('isPrimary' in value) || value['isPrimary'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    return true;
}

export function ContactPropertyLinkFromJSON(json: any): ContactPropertyLink {
    return ContactPropertyLinkFromJSONTyped(json, false);
}

export function ContactPropertyLinkFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContactPropertyLink {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'companyId': json['companyId'],
        'contactId': json['contactId'],
        'propertyId': json['propertyId'],
        'addressType': json['addressType'],
        'isPrimary': json['isPrimary'],
        'streetAddress': json['streetAddress'] == null ? undefined : json['streetAddress'],
        'city': json['city'] == null ? undefined : json['city'],
        'state': json['state'] == null ? undefined : json['state'],
        'zipCode': json['zipCode'] == null ? undefined : json['zipCode'],
        'createdAt': (new Date(json['createdAt'])),
    };
}

export function ContactPropertyLinkToJSON(json: any): ContactPropertyLink {
    return ContactPropertyLinkToJSONTyped(json, false);
}

export function ContactPropertyLinkToJSONTyped(value?: ContactPropertyLink | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'companyId': value['companyId'],
        'contactId': value['contactId'],
        'propertyId': value['propertyId'],
        'addressType': value['addressType'],
        'isPrimary': value['isPrimary'],
        'streetAddress': value['streetAddress'],
        'city': value['city'],
        'state': value['state'],
        'zipCode': value['zipCode'],
        'createdAt': ((value['createdAt']).toISOString()),
    };
}

